import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { createSelectable, TSelectableItemProps } from '../../../../components/drag-select';
import { Routes } from '../../../../utils/app-constants';
import { toLocalDateString, toSlashedShortDate } from '../../../../utils/date-utils';
import { ShipmentStatusMetadata } from '../../../../transportation/models/enums/shipment-status';
import { TruckSummary } from '../../../../transportation/models/trucks/truck-summary';

// #region Component Props

interface IProps extends TSelectableItemProps {
    truck : TruckSummary;
}

// #endregion

const TruckRow = (props: IProps) => {

    const { selectableRef, 
        isSelected, 
        isSelecting  
     } = props;

     let actualClass = 'order-selectable';
     actualClass += (props.truck.isChecked) ? ' highlight' : '';
     actualClass += (isSelecting) ? ' dragging' : '';
     actualClass += (isSelected) ? ' selected-already' : '';

    return <tr 
            ref={ selectableRef }
            className={`truck-row ${ actualClass }`}>
            <td>
                <NavLink 
                    className="punchthrough"
                    to={Routes.SHIPPING_TRUCK_EDIT_WITH_ID.formattify(props.truck.id)}>
                    { props.truck.id }
                </NavLink>
            </td>
            <td>
                <span className={ "text-uppercase shipment-status-color " + ShipmentStatusMetadata[props.truck.status].class }>
                    { ShipmentStatusMetadata[props.truck.status].display }
                </span>
            </td>
            <td>{ props.truck.name }</td>
            <td>{ props.truck.driverName }</td>
            <td>{ props.truck.cutoffDate ? toSlashedShortDate(props.truck.cutoffDate) : '' }</td>
            <td>
            { 
                props.truck.departureTime && props.truck.returnTime 
                ? `${ toLocalDateString(props.truck.departureTime.local, props.truck.departureTime.timeZone)}`
                : 'No Dates Set'  
            }
            </td>
        </tr>;
};

export default createSelectable(TruckRow);
